export default __webpack_public_path__ + "static/media/CISO.709cc18b.png";